import {
  Action,
  Selector,
  StateContext,
  State,
  Store,
  Select
} from '@ngxs/store';
import { User } from '../../models/auth/user';
import { SignInAuth, SignOutAuth, SignInHash, UpdateUserId } from '../actions/auth.action';
import { AddPassword } from '../actions/password';

export interface PasswordModel {
  value: String;
  confirmPassword: String;
}

export class AuthStateModel {
  jwtUser: string | null;
  user: User | null;
  cryptoToken: string | null;
  hash: string | null;
  password: PasswordModel | null;
}

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    jwtUser: null,
    user: null,
    cryptoToken: null,
    hash: null,
    password: null
  }
})
export class AuthState {
  constructor(protected store: Store) {}

  @Selector()
  static JTW(state: AuthStateModel) {
    return state.jwtUser;
  }

  @Selector()
  static CRYPTO(state: AuthStateModel) {
    return state.cryptoToken;
  }

  @Selector()
  static User(state: AuthStateModel) {
    return state.user;
  }

  @Selector()
  static HASH(state: AuthStateModel) {
    return state.hash;
  }

  @Selector()
  static password(state: AuthStateModel) {
    return state.password;
  }

  @Action(SignInHash)
  SignInHash(
    { patchState }: StateContext<AuthStateModel>,
    { hash }: SignInHash
  ) {
    patchState({ hash: hash });
  }

  @Action(AddPassword)
  AddPassword(
    { patchState }: StateContext<AuthStateModel>,
    { data }: AddPassword
  ) {
    patchState({
      password: { value: data.password, confirmPassword: data.confirmPassword }
    });
  }

  @Action(SignInAuth)
  SignInAuth(
    { patchState }: StateContext<AuthStateModel>,
    { auth }: SignInAuth
  ) {
    patchState({
      jwtUser: auth.jwt,
      user: auth.user,
      cryptoToken: auth.cryptoToken
    });
  }

  @Action(SignOutAuth)
  SignOutAuth({ patchState }: StateContext<AuthStateModel>, {}: SignOutAuth) {
    patchState({ jwtUser: null, user: null, cryptoToken: null });
  }

  @Action(UpdateUserId)
  UpdateUserId(
    { patchState }: StateContext<AuthStateModel>,
    { auth }: UpdateUserId
  ) {
    patchState({
      user: auth.user,
    });
  }
}
